// src/utils/confetti.js
import confetti from 'canvas-confetti';

const celebrateCompletion = () => {
  const duration = 3000;
  const end = Date.now() + duration;

  const colors = ['#16a34a', '#86efac']; // Green shades to match the theme

  (function frame() {
    confetti({
      particleCount: 2,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.8 },
      colors: colors
    });
    confetti({
      particleCount: 2,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.8 },
      colors: colors
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  }());
};

export default celebrateCompletion;